import { render, staticRenderFns } from "./EditAddMethodsParasiteAndFunc.vue?vue&type=template&id=666c8df0"
import script from "./EditAddMethodsParasiteAndFunc.vue?vue&type=script&lang=js"
export * from "./EditAddMethodsParasiteAndFunc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports